<h3 class="text-center">{{ 'feature.album.uploaded_album' | translate }}</h3>
<hr />
<div class="row row-cols-sm-auto gy-5">
  <div *ngFor="let album of albumPage.content; index as i" class="col-sm-3">
    <app-card [type]="1" [tileHoverEffect]="true">
      <div cardHeader1><a [routerLink]="['/album', 'detail']" [queryParams]="{id: album.id}">{{ album.title }}</a></div>
      <div cardText1 class="align-items-center w-100 h-100">
        <a [routerLink]="['/album', 'edit']" [queryParams]="{id: album.id}"
          ><img class="card-img img-thumbnail album-cover" [src]="album.coverUrl | mediaUrl" alt=""
        /></a>
      </div>
      <div cardFooter1 class="d-flex align-items-center justify-content-center">
        <button class="btn btn-info btn-sm rounded-circle mx-1" (click)="addAlbumToPlaying(album, $event)" [disabled]="album.isDisabled">
          <i class="bi bi-play"></i>
        </button>
        <a class="btn btn-secondary btn-sm rounded-circle mx-1" [routerLink]="['/album','edit']" [queryParams]="{id: album.id}"
          ><i class="bi bi-pencil-square"></i
        ></a>
      </div>
    </app-card>
  </div>
</div>
<ngb-pagination
  *ngIf="albumPage.totalPages > 1"
  [collectionSize]="albumPage.totalElements"
  [page]="albumPage.pageable?.pageNumber + 1"
  [pageSize]="albumPage.pageable?.pageSize"
  (pageChange)="getUserAlbumUploadedPage($event - 1)"
></ngb-pagination>
